<template>
  <div id="footer" class="container-fluid company-list">
    <div class="logo">
      <img :src="companies.length > 0 ? baseUrl + companies[0].cLogo : '@/assets/img/logo_black.png'" width="95px" height="45px"/>
    </div>
    <p class="title" v-for="(company, index) in companies" :key="index">{{company.cName}}</p>
    <p class="address_tel_fax">
      <span v-for="(company, index) in companies" :key="index">地址：{{company.cDz}}</span>
      <span v-for="(company, index) in companies" :key="index">Tel：{{company.cPhone}}</span>
    </p>
    <p class="email_wx">
      <span  v-for="(company, index) in companies" :key="index">邮箱：{{company.cEmail}}</span>
      <!--<span>微信号：xxx</span>-->
    </p>
    <p class="copy" v-for="(company, index) in companies" :key="index">Copyright &copy; 2018 - {{ new Date().getFullYear() }} {{company.cName}}</p>
  </div>
</template>
<script>
import request from '@/api/index.js'; // 导入用户提供的request实例
export default {
  name: "Footer",
  data() {
    return {
      companies: [], // 存储企业列表数据
      baseUrl: 'http://120.53.241.80:8080',
    };
  },
  //////////////////////////////////////////////////////////////////////////////接口代码片段保持不变
  created() {
  this.fetchCompanies(); // 调用接口获取数据
  //this.loadCompanyList();
  },
  methods: {
    async fetchCompanies() {
      try {
        // 利用用户提供的request实例发起请求（已配置baseURL和响应拦截器）
        const response = await request({
          method: 'GET',
          url: '/system/company/list' // 相对路径，baseURL已在index.js中配置
        });
        
        // 响应拦截器已处理为直接返回response.data，所以response即为接口返回的{code, rows, ...}
        if (response.code === 200) {
          this.companies = response.rows || []; // 直接从response.rows获取数据
          this.title1 = '1111111';
        } else {
          console.error('接口返回错误:', response.msg);
        }
      } catch (error) {
        console.error('请求失败:', error);
      }
    },
    loadCompanyList() {
      // 保留原方法实现
    },
  },
  
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue